import Footer from "../footer/footer";
import Navbar from "../navbar/navbar";
import fieldbus from '../../assets/Absolute Pressure Transmitter.png';
import diffpresure from '../../assets/Differential Pressure Transmitter.png';
import AbsolutePressure from '../../assets/Absolute Pressure Transmitter.png';
import guage from '../../assets/Gauge Pressure.jpg';
import Banner from '../../assets/Transmitter.jpg';
import { Helmet } from "react-helmet";
import React from "react";
import { 
  FaIndustry, 
  FaTools, 
  FaWater, 
  FaFlask,
  FaCogs,
  FaChartLine,
  FaShieldAlt,
  FaHeadset,
  FaCubes,
  FaCheck
} from "react-icons/fa";
import { HiOutlineBadgeCheck } from "react-icons/hi";
import { FaOilWell } from "react-icons/fa6";

const Transmitter: React.FC = () => {
    return (
      <><Helmet>
        <title>Industrial Pressure Transmitters Manufacturer & Exporter | Gauge, Differential, Absolute</title>
        <meta 
          name="description" 
          content="City Cat International – Trusted manufacturer & global exporter of industrial pressure transmitters: Gauge, Absolute, Differential & Fieldbus types for oil, gas & process industries." 
        />
        <meta 
          name="keywords" 
          content="industrial pressure transmitters manufacturer, gauge pressure transmitter exporter, differential pressure transmitter supplier, absolute pressure sensor manufacturer, fieldbus transmitters India, SIL certified transmitters, process automation pressure transmitters, oil and gas pressure transmitters, City Cat International" 
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.oilandgasindustrialequipmentsupply.com/pressure-transmitter" />
        
        <meta property="og:title" content="Premium Pressure Transmitters Manufacturer & Global Supplier" />
        <meta property="og:description" content="Exporting high-precision transmitters to 40+ countries. SIL 2/3 certified with 25+ years expertise in process measurement solutions." />
        <meta property="og:image" content="https://www.oilandgasindustrialequipmentsupply.com/assets/transmitter-banner.jpg" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Industrial Transmitters for Process Control | City Cat International" />
        <meta name="twitter:description" content="Global supplier of SIL-certified pressure transmitters for refineries, pipelines, and chemical plants. Request technical specs." />
        
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "ProductPage",
            "name": "Industrial Pressure Transmitters",
            "description": "Manufacturer and exporter of premium industrial transmitters for global operations",
            "url": "https://www.oilandgasindustrialequipmentsupply.com/pressure-transmitter",
            "image": "https://www.oilandgasindustrialequipmentsupply.com/assets/transmitter-banner.jpg",
            "brand": {
              "@type": "Brand",
              "name": "City Cat International"
            },
            "manufacturer": {
              "@type": "Organization",
              "name": "City Cat International"
            }
          }
          `}
        </script>
      </Helmet>
      <Navbar />
      
      {/* Hero Banner */}
      <div className="relative bg-gray-900 mt-24">
          <img 
              src={Banner} 
              alt="Industrial Pressure Transmitters for Process Control" 
              className="w-full h-96 object-cover opacity-70"
          />
          <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                  Precision Pressure Measurement Solutions
              </h1>
              <p className="text-xl text-white max-w-3xl">
                  Premium Gauge, Absolute, Differential & Fieldbus Transmitters for Industrial Applications
              </p>
          </div>
      </div>

      {/* Industries Served Section */}
      <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
              <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                  Transmitters for Critical Industries
              </h2>
              
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-5xl mx-auto">
                  {[
                      { icon: <FaOilWell />, name: "Oil & Gas" },
                      { icon: <FaWater />, name: "Water Treatment" },
                      { icon: <FaIndustry />, name: "Chemical" },
                      { icon: <FaTools />, name: "Manufacturing" },
                      { icon: <FaFlask />, name: "Pharmaceutical" },
                      { icon: <FaOilWell />, name: "Power Generation" }
                  ].map((industry, index) => (
                      <div key={index} className="bg-white p-6 rounded-lg shadow-sm text-center">
                          <div className="text-rose-600 text-3xl mb-3 flex justify-center">
                              {industry.icon}
                          </div>
                          <h3 className="font-semibold text-gray-800">{industry.name}</h3>
                      </div>
                  ))}
              </div>
          </div>
      </section>

      {/* Comprehensive Solutions Section */}
      <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
              <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                  Comprehensive Measurement Solutions
              </h2>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 max-w-6xl mx-auto">
                  {[
                      { 
                          icon: <FaCogs className="text-4xl mb-4" />,
                          title: "Custom Engineering",
                          desc: "Specialized designs for unique process conditions"
                      },
                      { 
                          icon: <FaChartLine className="text-4xl mb-4" />,
                          title: "Accuracy Assurance",
                          desc: "0.05% FS accuracy with NIST-traceable calibration"
                      },
                      { 
                          icon: <FaShieldAlt className="text-4xl mb-4" />,
                          title: "Safety Compliance",
                          desc: "SIL 2/3, ATEX, IECEx certified designs"
                      },
                      { 
                          icon: <FaHeadset className="text-4xl mb-4" />,
                          title: "24/7 Support",
                          desc: "Global technical assistance with rapid response"
                      },
                      { 
                          icon: <FaCubes className="text-4xl mb-4" />,
                          title: "Calibration Services",
                          desc: "ISO 17025 accredited calibration facilities"
                      }
                  ].map((feature, index) => (
                      <div key={index} className="bg-gray-50 p-6 rounded-lg text-center">
                          <div className="text-rose-600 flex justify-center">{feature.icon}</div>
                          <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                          <p className="text-gray-700">{feature.desc}</p>
                      </div>
                  ))}
              </div>
          </div>
      </section>

      <div className="bg-white">
          <h2 className="text-center text-gray-800 text-4xl lg:text-5xl font-bold leading-tight pt-16">
             Transmitter Range
          </h2>
          <div className="my-4 mx-auto w-16 h-2 border-4 border-rose-600 mb-20"></div>

          {/* Gauge Pressure Transmitter */}
          <section data-aos="fade-right">
            <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
              <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full">
                  <img
                    alt="Gauge Pressure Transmitter for industrial applications"
                    src={guage}
                    className="absolute inset-0 h-full w-full object-contain" />
                </div>
                <div className="lg:py-16">
                  <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">Gauge Pressure Transmitters</h2>
                  
                  <div className="my-6">
                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                      <li>Range: -1 to 600 bar</li>
                      <li>Accuracy: ±0.075% FS</li>
                      <li>Output: 4-20mA HART, Modbus, Foundation Fieldbus</li>
                      <li>Materials: 316SS, Hastelloy, Monel</li>
                    </ul>
                  </div>
                  
                  <p className="mt-4 text-gray-600 text-lg text-justify">
                    Our gauge pressure transmitters feature advanced ceramic or silicon sensing elements with 
                    temperature-compensated circuitry for exceptional stability. Designed with welded metal seals 
                    and optional diaphragm seals, they provide reliable measurement in open tank level, line pressure, 
                    and hydraulic systems. With SIL 2/3 certification and explosion-proof housings, they ensure 
                    safety in hazardous environments while maintaining 5-year stability for reduced recalibration needs.
                  </p>
                  
                  <div className="mt-8 flex justify-center">
                    <a
                      href="/contact"
                      className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                    >
                      Request Technical Specs
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Absolute Pressure Transmitter */}
          <section data-aos="fade-left">
            <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
              <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-first lg:h-full">
                  <img
                    alt="Absolute Pressure Transmitter for vacuum applications"
                    src={AbsolutePressure}
                    className="absolute inset-0 h-full w-full object-contain" />
                </div>
                <div className="lg:py-16">
                  <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">Absolute Pressure Transmitters</h2>
                  
                  <div className="my-6">
                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                      <li>Range: 0-2500 mbar abs</li>
                      <li>Accuracy: ±0.1% FS</li>
                      <li>Reference: Full vacuum sealed</li>
                      <li>Process Connection: 1/2" to 2" NPT/Flange</li>
                    </ul>
                  </div>
                  
                  <p className="mt-4 text-gray-600 text-lg text-justify">
                    Engineered with hermetically sealed vacuum reference cells, our absolute pressure transmitters 
                    provide stable measurements unaffected by atmospheric pressure changes. Featuring advanced ASIC 
                    technology with digital temperature compensation, they deliver precise readings in distillation 
                    columns, vacuum systems, and altitude measurement applications. Optional remote diaphragm seals 
                    with capillary systems allow measurement of viscous or corrosive media without process contact.
                  </p>
                  
                  <div className="mt-8 flex justify-center">
                    <a
                      href="/contact"
                      className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                    >
                      Get Vacuum-Specific Quote
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Differential Pressure Transmitter */}
          <section data-aos="fade-right">
            <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
              <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full">
                  <img
                    alt="Differential Pressure Transmitter for flow measurement"
                    src={diffpresure}
                    className="absolute inset-0 h-full w-full object-contain" />
                </div>
                <div className="lg:py-16">
                  <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">Differential Pressure Transmitters</h2>
                  
                  <div className="my-6">
                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                      <li>Range: 0.1 mbar to 400 bar</li>
                      <li>Accuracy: ±0.04% FS</li>
                      <li>Static Pressure: Up to 400 bar</li>
                      <li>Overpressure Protection: 400% FS</li>
                    </ul>
                  </div>
                  
                  <p className="mt-4 text-gray-600 text-lg text-justify">
                    Our differential pressure transmitters feature advanced capacitive or piezoresistive sensors 
                    with welded stainless steel isolation diaphragms for exceptional durability. Designed for 
                    precise flow measurement, level detection, and filter monitoring, they incorporate smart 
                    diagnostics for plugging detection and process anomalies. With 5-point linearization and 
                    advanced digital signal processing, they maintain accuracy across wide temperature ranges 
                    from -40°C to 125°C.
                  </p>
                  
                  <div className="mt-8 flex justify-center">
                    <a
                      href="/contact"
                      className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                    >
                      Request Flow Measurement Package
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Fieldbus Transmitters */}
          <section data-aos="fade-left">
            <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
              <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
                <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-first lg:h-full">
                  <img
                    alt="Fieldbus Transmitters for digital networks"
                    src={fieldbus}
                    className="absolute inset-0 h-full w-full object-contain" />
                </div>
                <div className="lg:py-16">
                  <h2 className="text-4xl text-gray-800 text-center font-bold sm:text-4xl">Fieldbus Transmitters</h2>
                  
                  <div className="my-6">
                    <h3 className="text-xl font-semibold text-rose-600 mb-2">Key Specifications:</h3>
                    <ul className="list-disc pl-5 text-gray-700 space-y-1">
                      <li>Protocols: Foundation Fieldbus, PROFIBUS PA</li>
                      <li>Communication Speed: 31.25 kbit/s</li>
                      <li>Intrinsic Safety: Entity, FISCO models</li>
                      <li>Diagnostics: Advanced PdM capabilities</li>
                    </ul>
                  </div>
                  
                  <p className="mt-4 text-gray-600 text-lg text-justify">
                    Our fieldbus transmitters deliver multi-variable measurement with digital communication 
                    capabilities for modern process automation. Featuring dual-channel capability for simultaneous 
                    pressure and temperature measurement, they reduce installation costs while providing enhanced 
                    diagnostics. With advanced power management and bus-powered operation, they enable predictive 
                    maintenance through continuous monitoring of device health and process conditions.
                  </p>
                  
                  <div className="mt-8 flex justify-center">
                    <a
                      href="/contact"
                      className="inline-block rounded bg-rose-600 px-8 py-3 text-md font-medium text-white transition hover:bg-rose-700 focus:outline-none focus:ring focus:ring-rose-300"
                    >
                      Discuss Digital Integration
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
      </div>

      {/* Oil & Gas Applications */}
      <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
              <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                  Transmitter Applications in Oil & Gas
              </h2>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
                  {[
                      {
                          title: "Wellhead Monitoring",
                          content: "High-pressure transmitters for choke valve control"
                      },
                      {
                          title: "Pipeline SCADA",
                          content: "Leak detection systems with differential pressure"
                      },
                      {
                          title: "Distillation Columns",
                          content: "Precise level and pressure control in refining"
                      },
                      {
                          title: "Tank Farm Management",
                          content: "Inventory control with hydrostatic level measurement"
                      },
                      {
                          title: "Compressor Control",
                          content: "Anti-surge protection systems"
                      },
                      {
                          title: "Fiscal Metering",
                          content: "Custody transfer flow measurement"
                      }
                  ].map((app, index) => (
                      <div key={index} className="bg-white p-6 rounded-lg shadow-sm">
                          <h3 className="text-xl font-bold text-rose-600 mb-3">{app.title}</h3>
                          <p className="text-gray-700">{app.content}</p>
                      </div>
                  ))}
              </div>
          </div>
      </section>

      {/* Enhanced Technical Support CTA */}
      <section className="py-16 bg-gradient-to-r from-rose-700 to-rose-900 text-white">
          <div className="container mx-auto px-4 text-center">
              <div className="max-w-4xl mx-auto">
                  <h2 className="text-3xl md:text-4xl font-bold mb-6">
                      Need Measurement Engineering Support?
                  </h2>
                  <p className="text-xl mb-10">
                      Our SIL-certified engineers provide:
                  </p>
                  
                  <div className="grid md:grid-cols-3 gap-6 mb-12">
                      {[
                          "System Design & Integration",
                          "SIL Verification & Validation",
                          "Calibration Services",
                          "Troubleshooting & Diagnostics",
                          "Hazardous Area Certification",
                          "Legacy System Upgrades"
                      ].map((service, index) => (
                          <div key={index} className="flex items-start">
                              <HiOutlineBadgeCheck className="text-2xl mt-1 mr-3 text-rose-200 flex-shrink-0" />
                              <span>{service}</span>
                          </div>
                      ))}
                  </div>
                  
                  <div className="flex flex-col sm:flex-row justify-center gap-4">
                      <a
                          href="tel:+919819600149"
                          className="bg-white text-rose-700 hover:bg-gray-100 font-bold py-3 px-8 rounded-lg transition duration-300"
                      >
                          Call: +91 9819600149
                      </a>
                      <a
                          href="mailto:info@oilandgasindustrialequipmentsupply.com"
                          className="border-2 border-white hover:bg-rose-800 font-bold py-3 px-8 rounded-lg transition duration-300"
                      >
                          Email Technical Team
                      </a>
                  </div>
              </div>
          </div>
      </section>

      {/* Project Case Studies */}
      <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
              <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                  Global Transmitter Projects
              </h2>
              
              <div className="max-w-5xl mx-auto">
                  <div className="grid md:grid-cols-2 gap-8">
                      <div className="bg-gray-50 p-6 rounded-lg">
                          <h3 className="text-xl font-bold text-rose-600 mb-3">Offshore Platform Automation</h3>
                          <p className="text-gray-700 mb-4">
                              <span className="font-semibold">Location:</span> North Sea<br />
                              <span className="font-semibold">Solution:</span> SIL 3 certified transmitters<br />
                              <span className="font-semibold">Quantity:</span> 450+ units<br />
                              <span className="font-semibold">Features:</span> Subsea-rated, titanium construction
                          </p>
                          <div className="flex items-center">
                              <FaCheck className="text-green-600 mr-2" />
                              <span>Zero transmitter failures in 3 years of operation</span>
                          </div>
                      </div>
                      
                      <div className="bg-gray-50 p-6 rounded-lg">
                          <h3 className="text-xl font-bold text-rose-600 mb-3">Refinery Expansion Project</h3>
                          <p className="text-gray-700 mb-4">
                              <span className="font-semibold">Location:</span> Middle East<br />
                              <span className="font-semibold">Solution:</span> Foundation Fieldbus transmitters<br />
                              <span className="font-semibold">Quantity:</span> 1,200+ units<br />
                              <span className="font-semibold">Features:</span> Multi-variable measurement
                          </p>
                          <div className="flex items-center">
                              <FaCheck className="text-green-600 mr-2" />
                              <span>30% reduction in installation costs</span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
     
      <Footer />
      </>
    );
};

export default Transmitter;